import { ReactNode, useState } from 'react';
import { Modal, Select, Button, Spin, Typography } from 'antd';
import { EnvironmentOutlined } from '@ant-design/icons';
import { useBuildingContext } from '../../context/BuildingContext';

const { Title, Text } = Typography;

interface Props {
	children: ReactNode;
}

export default function BuildingGate({ children }: Props) {
	const { buildings, isLoading, isResolved, setBuildingId } = useBuildingContext();
	const [selectedId, setSelectedId] = useState<string | null>(null);

	if (isLoading) {
		return (
			<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
				<Spin size="large" />
			</div>
		);
	}

	if (isResolved) {
		return <>{children}</>;
	}

	return (
		<Modal
			open
			closable={false}
			maskClosable={false}
			footer={null}
			centered
			width={480}
		>
			<div style={{ textAlign: 'center', padding: '24px 0' }}>
				<EnvironmentOutlined style={{ fontSize: 48, color: '#1890ff', marginBottom: 16 }} />
				<Title level={3}>Select Building</Title>
				<Text type="secondary">
					Choose the building this tablet is located in. All operations will be
					filtered to this building.
				</Text>
				<div style={{ marginTop: 24 }}>
					<Select
						placeholder="Select a building"
						style={{ width: '100%' }}
						size="large"
						value={selectedId}
						onChange={setSelectedId}
					>
						{buildings.map((b) => (
							<Select.Option key={b.id} value={b.id}>
								{b.name}
							</Select.Option>
						))}
					</Select>
				</div>
				<Button
					type="primary"
					size="large"
					block
					style={{ marginTop: 16 }}
					disabled={!selectedId}
					onClick={() => {
						if (selectedId) setBuildingId(selectedId);
					}}
				>
					Confirm
				</Button>
			</div>
		</Modal>
	);
}
